// Tenant-specific routes
import TenantDashboard from '@/pages/inside/tenant/Dashboard';
import TenantStudents from '@/pages/inside/tenant/Students';
import TenantTeachers from '@/pages/inside/tenant/Teachers';
import TenantStaff from '@/pages/inside/tenant/Staff';
import TenantClassesSubjects from '@/pages/inside/tenant/ClassesSubjects';
import TenantProfile from '@/pages/inside/tenant/Profile';
import TenantSettings from '@/pages/inside/tenant/Settings';
import SchoolTimeConfig from '@/pages/inside/tenant/SchoolTimeConfig';
import TeacherAttendance from '@/pages/inside/tenant/TeacherAttendance';
import StaffAttendance from '@/pages/inside/tenant/StaffAttendance';
import StudentAttendance from '@/pages/inside/tenant/StudentAttendance';
import ExpenseLedger from '@/pages/inside/tenant/finance/ExpenseLedger';
import ReceiveLedger from '@/pages/inside/tenant/finance/ReceiveLedger';
import TransactionLedger from '@/pages/inside/tenant/finance/TransactionLedger';
import FinanceAccounts from '@/pages/inside/tenant/finance/FinanceAccounts';
import FeesManagement from '@/pages/inside/tenant/fees/FeesManagement';
import Homeworks from '@/pages/inside/tenant/Homeworks';
import NoticesAnnouncements from '@/pages/inside/tenant/NoticesAnnouncements';
import TenantTimetable from '@/pages/inside/tenant/Timetable';
import TeacherAttendanceKiosk from '@/pages/inside/tenant/TeacherAttendanceKiosk';

export const tenantRoutes = [
    {
        path: '/public/attendance',
        component: TeacherAttendanceKiosk,
    },
    {
        path: '/dashboard',
        component: TenantDashboard,
        menuItem: {
            key: '/dashboard',
            label: 'Dashboard',
        }
    },
    {
        path: '/tenant/dashboard',
        component: TenantDashboard,
        menuItem: {
            key: '/tenant/dashboard',
            label: 'Dashboard',
        }
    },
    {
        path: '/tenant/students',
        component: TenantStudents,
        requireAbility: [['read', 'Students'], ['manage', 'Students']],
        menuItem: {
            key: '/tenant/students',
            label: 'Students',
        }
    },
    {
        path: '/tenant/teachers',
        component: TenantTeachers,
        requireAbility: [['read', 'Teachers'], ['manage', 'Teachers']],
        menuItem: {
            key: '/tenant/teachers',
            label: 'Teachers',
        }
    },
    {
        path: '/tenant/staff',
        component: TenantStaff,
        requireAbility: [['read', 'Staff'], ['manage', 'Staff']],
        menuItem: {
            key: '/tenant/staff',
            label: 'Staff',
        }
    },
    {
        path: '/tenant/classes-subjects',
        component: TenantClassesSubjects,
        requireAbility: [['read', 'Classes'], ['manage', 'Classes']],
        menuItem: {
            key: '/tenant/classes-subjects',
            label: 'Classes & Badge',
        }
    },
    {
        path: '/tenant/profile',
        component: TenantProfile,
        requireAbility: [['read', 'TenantProfile'], ['manage', 'TenantProfile']],
        menuItem: {
            key: '/tenant/profile',
            label: 'School Profile',
        },
    },
    {
        path: '/tenant/settings',
        component: TenantSettings,
        requireAbility: [['read', 'Preferences'], ['manage', 'Preferences']],
    },
    {
        path: '/tenant/school-time',
        component: SchoolTimeConfig,
        menuItem: {
            key: '/tenant/school-time',
            label: 'School Time',
        },
    },
    {
        path: '/tenant/attendance/teachers',
        component: TeacherAttendance,
    },
    {
        path: '/tenant/attendance/staff',
        component: StaffAttendance,
    },
    {
        path: '/tenant/attendance/students',
        component: StudentAttendance,
        requireAbility: [['read', 'StudentAttendance'], ['manage', 'StudentAttendance']],
    },
    {
        path: '/tenant/finance/expense-ledger',
        component: ExpenseLedger,
        requireAbility: [['read', 'ExpenseLedger'], ['manage', 'ExpenseLedger']],
    },
    {
        path: '/tenant/finance/receive-ledger',
        component: ReceiveLedger,
        requireAbility: [['read', 'ReceiveLedger'], ['manage', 'ReceiveLedger']],
    },
    {
        path: '/tenant/finance/transaction-ledger',
        component: TransactionLedger,
        requireAbility: [['read', 'TransactionLedger']],
    },
    {
        path: '/tenant/finance/accounts',
        component: FinanceAccounts,
        requireAbility: [['read', 'FinanceAccounts'], ['manage', 'FinanceAccounts']],
    },
    {
        path: '/tenant/homeworks',
        component: Homeworks,
        menuItem: {
            key: '/tenant/homeworks',
            label: 'Homework Diary',
        },
    },
    {
        path: '/tenant/fees-management',
        component: FeesManagement,
        requireAbility: [['read', 'FeesManagement'], ['manage', 'FeesManagement']],
    },
    {
        path: '/tenant/notices-announcements',
        component: NoticesAnnouncements,
        menuItem: {
            key: '/tenant/notices-announcements',
            label: 'Notices',
        },
    },
    {
        path: '/tenant/timetable',
        component: TenantTimetable,
        menuItem: {
            key: '/tenant/timetable',
            label: 'Time Table',
        },
    },
    // Add more tenant routes here
];

